<template>
	<div class="ziList">
		<Zi></Zi>
		<LeftList></LeftList>
	</div>
	
</template>

<script>
	import Zi from "@/components/Zi.vue";
	import LeftList from "@/components/LeftList.vue";
	export default {
	  name: "ZiList",
	  components: {
		Zi,
		LeftList
	  },
	};
</script> 

<style scoped lang="scss">
	.ziList {
		width: 1200px;
		// height: 100px;
		// background-color: #0f1;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
</style>
